import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters, onUploadClick }) => {
  if (hasFilters) {
    return (
      <div className="card p-8 md:p-12 text-center">
        <div className="flex flex-col items-center gap-6 max-w-md mx-auto">
          <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-accent-cyan/10 border border-accent-cyan/20">
            <Icon name="Search" size={40} color="var(--color-accent-cyan)" />
          </div>
          
          <div>
            <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
              No Rotations Found
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              No rotations match your current filter criteria. Try adjusting your filters or clearing them to see all rotations.
            </p>
          </div>

          <Button
            variant="outline"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All Filters
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="card p-8 md:p-12 text-center">
      <div className="flex flex-col items-center gap-6 max-w-md mx-auto">
        <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-accent-cyan/10 border border-accent-cyan/20">
          <Icon name="Plane" size={40} color="var(--color-accent-cyan)" />
        </div>
        
        <div>
          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
            No Rotations Yet
          </h3>
          <p className="text-sm md:text-base text-muted-foreground">
            Get started by uploading your first rotation data. You can paste rotation information and we'll parse it automatically.
          </p>
        </div>

        <Button
          variant="default"
          iconName="Upload"
          iconPosition="left"
          onClick={onUploadClick}
        >
          Upload First Rotation
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;